import Blue from "~/core";

new Blue({
  name: "tabs",
  selector: ".tabs",
  setup(tabs) {
    const triggers = [...tabs.querySelectorAll(".tabs__trigger")];
    const highlight = tabs.querySelector(".tabs__highlight");
    let mediaQuery;

    const determineMQ = () => {
      let container = tabs.closest("[page-cols]") || tabs.closest('.section__inner') || document.body;
      let width = 0;
      triggers.forEach(t => width += t.offsetWidth);
      width += 100;
      
      width = width > container.offsetWidth ? 1000000 : width;

      mediaQuery = window.matchMedia(`(min-width: ${width}px)`);
      tabs.classList.add("is-initialized");
      !mediaQuery.matches ? tabs.classList.remove("is-tabs"): false;

      mediaQuery.addEventListener("change", e => {
        if (e.matches) {
          tabs.classList.add("is-tabs");
        } else {
          tabs.classList.remove("is-tabs");
        }
      });
    };

    determineMQ();

    const moveHighlight = trigger => {
      if (trigger === highlight.closest(".tabs__trigger")) return;

      let startX, startY, endX, endY;

      startX = highlight.getBoundingClientRect().left;
      startY = highlight.getBoundingClientRect().top;
      trigger.insertAdjacentElement("afterbegin", highlight);
      endX = highlight.getBoundingClientRect().left;
      endY = highlight.getBoundingClientRect().top;

      highlight.animate(
        [
          { transform: `translate(${startX - endX}px, ${startY - endY}px)` },
          { transform: `translate(0,0)` }
        ],
        {
          duration: 250,
          easing: "ease"
        }
      );
    };

    triggers.forEach(trigger => {
      let content = tabs.querySelector(
        `.tabs__content[data-tab=${trigger.dataset.trigger}]`
      );
      let siblings = triggers.filter(sib => sib !== trigger);

      trigger.addEventListener("click", () => {
        let start, end;

        siblings.forEach(sib => {
          let sib_content = tabs.querySelector(
            `.tabs__content[data-tab=${sib.dataset.trigger}]`
          );
          let sib_start, sib_end;

          sib_start = sib_content.offsetHeight;
          sib.classList.remove("is-active");
          sib_content.classList.remove("is-active");
          sib_end = sib_content.offsetHeight;

          sib_content.animate(
            [{ height: `${sib_start}px` }, { height: `${sib_end}px` }],
            { duration: 250, easing: "ease" }
          );
        });

        start = content.offsetHeight;
        if (mediaQuery.matches) {
          trigger.classList.add("is-active");
          content.classList.add("is-active");
        } else {
          trigger.classList.toggle("is-active");
          content.classList.toggle("is-active");
        }
        end = content.offsetHeight;
        content.animate([{ height: `${start}px` }, { height: `${end}px` }], {
          duration: 250,
          easing: "ease"
        });
        moveHighlight(trigger);
      });
    });
  }
});
